export default __webpack_public_path__ + "static/media/swimming.0b9b8a1d.jpg";